import { Checkbox, CheckboxGroup, CheckboxGroupProps, CheckboxProps } from '@vechaiui/react';
import { useField } from 'formik';

import Field from '#/components/forms/Field';
import { STATE_LIST } from '#/constants/malaysia-state-list';
import { isRequiredYupField, useYupRequiredFields } from '#/components/forms/Formik';

export const MalaysiaStateCheckboxGroup: React.FC<MalaysiaStateCheckboxGroupProps> = ({
  invalid,
  readOnly,
  disabled,
  required,
  ...props
}) => {
  const checkboxProps = { invalid, readOnly, disabled, required };

  return (
    <CheckboxGroup className="space-y-2" {...props}>
      {STATE_LIST.map((state) => (
        <Checkbox {...checkboxProps} key={state.code} value={state.code}>
          {state.name}
        </Checkbox>
      ))}
    </CheckboxGroup>
  );
};

export type MalaysiaStateCheckboxGroupProps = Omit<CheckboxGroupProps, 'children'> &
  Pick<CheckboxProps, 'readOnly' | 'disabled' | 'invalid' | 'required'>;

export const MalaysiaStateCheckboxGroupFormik: React.FC<MalaysiaStateCheckboxGroupFormikProps> = ({
  name,
  invalid,
  ...props
}) => {
  const [field, meta, helper] = useField(name);
  const requiredFields = useYupRequiredFields();
  const isRequired = isRequiredYupField(requiredFields, name);
  const showError = meta.touched && !!meta.error;

  return (
    <Field name={name}>
      <MalaysiaStateCheckboxGroup
        {...field}
        size="lg"
        {...props}
        invalid={invalid ?? showError}
        onChange={helper.setValue}
        required={isRequired}
      />
    </Field>
  );
};
export type MalaysiaStateCheckboxGroupFormikProps = MalaysiaStateCheckboxGroupProps & {
  name: string;
};

export default MalaysiaStateCheckboxGroup;
